import React from 'react';
import Modal from 'react-modal';

import BugsnagErrorBoundary from 'components/core/Bugsnag';
import TranslationsProvider from 'components/providers/TranslationsProvider';
import GraphQLProvider from 'components/providers/GraphQLProvider';
import { V3ApiClientProvider } from 'components/providers';
import ReduxProvider from 'components/providers/ReduxProvider';
import LaunchDarklyProvider from 'components/providers/LaunchDarklyProvider';
import ReactRoutesProvider from './providers/ReactRoutes/ReactRoutesProvider';
import { AmplitudeProvider } from './providers/AmplitudeProvider';

const isDevEnvironment = process.env.NODE_ENV === 'development';

type AppContainerProps = {
  children: React.ReactNode;
  reactClassForV3ApiClient?: string;
  modalMountId: string;
};

function AppContainer({
  children,
  reactClassForV3ApiClient,
  modalMountId,
}: AppContainerProps) {
  const mainElement = document.querySelector(`#${modalMountId}`);
  if (mainElement) {
    Modal.setAppElement(`#${modalMountId}`);
  }

  return (
    <TranslationsProvider>
      <BugsnagErrorBoundary disabled={isDevEnvironment}>
        <ReactRoutesProvider>
          <GraphQLProvider>
            <V3ApiClientProvider reactClass={reactClassForV3ApiClient}>
              <ReduxProvider>
                <AmplitudeProvider>
                  <LaunchDarklyProvider>{children}</LaunchDarklyProvider>
                </AmplitudeProvider>
              </ReduxProvider>
            </V3ApiClientProvider>
          </GraphQLProvider>
        </ReactRoutesProvider>
      </BugsnagErrorBoundary>
    </TranslationsProvider>
  );
}

export default AppContainer;
